import React from 'react';
import { VideoSection } from '../components/VideoSection';
import { Countdown } from '../components/Countdown';

export const VideosPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 pt-24">
      <div className="container mx-auto px-4 lg:px-8 py-8">
        <Countdown />
      </div>
      <VideoSection />
    </div>
  );
};